// removed by extract-text-webpack-plugin
module.exports = {"errorNotification":"errorNotification-2_OJE","errorNotificationText":"errorNotificationText-pyvyq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/notifications/_error.css
// module id = 1236
// module chunks = 1